import cxs from 'cxs';
import { COLOURS } from '../../../common/styles/vars';

export const DISABLED = cxs({
  cursor: 'default',
  opacity: '0.6'
});

export const TOGGLE = cxs({
  display: 'flex',
  alignItems: 'center'
});

export const SWITCH = cxs({
  position: 'relative',
  cursor: 'pointer',
  display: 'inline-block',
  width: '40px',
  height: '20px'
});

export const SWITCH_INPUT = cxs({
  opacity: '0',
  width: '0',
  height: '0'
});

export const SLIDER = ({ checked } = {}) => cxs({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  transition: '.4s',
  webkitTransition: '.4',
  borderRadius: '20px',
  backgroundColor: checked ? COLOURS.cyan.jungleGreen.monkey : COLOURS.grey.mischka.russian
});

export const SLIDER_BEFORE = ({ checked } = {}) => cxs({
  position: 'absolute',
  content: '""',
  height: '16px',
  width: '16px',
  left: '3px',
  bottom: '2px',
  transition: '.4s',
  webkitTransition: '.4',
  borderRadius: '20px',
  zIndex: 1,
  backgroundColor: COLOURS.mono.white,
  transform: checked ? 'translateX(18px)' : 0
});